import React from 'react';
import img from './../img/agni.png';
import img1 from "./../img/aartees.png";
import img2 from "./../img/kk.png";
import img3 from "./../img/medjob.png";
import img4 from "./../img/msmslogo.png";
import img5 from "./../img/skywings.png";
import img6 from "./../img/guiders.png";
import img7 from "./../img/zakirhusaindelhicollege.png";
import img8 from "./../img/universityofdelhi.png"
import img9 from "./../img/image7.PNG";
const TrustedLogos = () => (
  <div className="w-full mt-10">
    <p className="text-center lg:text-left text-base lg:text-2xl font-semibold lg:font-bold text-gray-600 mb-6" data-aos="fade-up">
      Trusted by Institutions and millions of learners around the world
    </p>
    {/* First row - Largest size */}
    <div className='flex justify-center items-center mb-4  gap-2'>
      <img src={img8} alt="University of Delhi" className="h-10 lg:h-20 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img7} alt="Zakir Husain Delhi College" className="h-12 lg:h-20 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img4} alt="Mahavir Senior Model School" className="h-10 lg:h-20 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" /> 
    </div>
    {/* Second row - Medium size */}
    <div className='flex justify-center items-center mb-4 flex-wrap gap-2'>
      <img src={img9} alt="" className="h-10 lg:h-16 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img2} alt="K&KTalents" className="h-6 lg:h-8 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img1} alt="AARTEES" className="h-8 lg:h-16 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img3} alt="Medical Jobs" className="h-8 lg:h-16 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
    </div>
    {/* Third row - Smallest size */}
    <div className='flex justify-center items-center flex-wrap gap-2'>
      <img src={img5} alt="SkyWings" className="h-6 lg:h-10 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <img src={img6} alt="Guiders" className="h-6 lg:h-10 w-auto mx-2 lg:mx-5 object-contain" data-aos="fade-up" />
      <a href="https://www.instagram.com/_agni.x_/" target="_blank" rel="noopener noreferrer">
        <img src={img} alt="Agni Language Services" className="h-6 lg:h-10 w-auto mx-2 lg:mx-5 object-contain hover:scale-105 transition-transform" data-aos="fade-up" />
        {/* Empty fragment to balance the opening tag */}
        {/* </> */}
        {/* <div> */}
      </a>
    </div>
  </div>
);

export default TrustedLogos;
